import React, { useState, useEffect } from "react";
import { Image, Table } from "react-bootstrap";
import { Col, Row, Tabs, Tab } from "react-bootstrap-v5";
import Offcanvas from "react-bootstrap/Offcanvas";
import * as moment from "moment";

const ShowPropertyDetail = ({
  showPropertyDetail,
  setShowOffcanvas,
  property,
  isSubscribedUser,
}) => {
  return (
    <Offcanvas
      show={showPropertyDetail}
      onHide={() => setShowOffcanvas(false)}
      placement="end"
      className="offcanvas-style"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {property
            ? `${property.SitusFullStreetAddress || "-"}, ${
                property.SitusCity || "-"
              } ${property.SitusState || "-"} ${property.SitusZIP5 || "-"}`
            : ""}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {/* <Row>
                    <Col>
                        <Image src={require('./../../assets/img/home.png')} className='img-fluid' />
                    </Col>
                </Row> */}
        <ul className="detailLis_canvas">
          <li>
            <p>{property.Bedrooms || "-"}</p>
            <h6>Beds</h6>
          </li>
          <li>
            <p>{property.BathFull || "-"}</p>
            <h6>Baths</h6>
          </li>
          <li>
            <p>{property.SumBuildingSqFt || "-"}</p>
            <h6>Sq. Ft.</h6>
          </li>
          <li>
            <p>
              $
              {property.AssdTotalValue
                ? Number(property.AssdTotalValue).toLocaleString()
                : ""}
            </p>
            <h6>Est. Value</h6>
          </li>
          <li>
            <p>{property.YearBuilt || ""}</p>
            <h6>Yr. Build</h6>
          </li>
        </ul>
        <Tabs
          defaultActiveKey="home"
          id="fill-tab-example"
          className="mb-3"
          fill
        >
          <Tab
            eventKey="home"
            title={
              <>
                Property <br /> Overview
              </>
            }
          >
            <h4 className="tabHeading">Address Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        APN{" "}
                        <span className="tip">
                          Assessor's Parcel Number or Parcel Identification
                          Number. An arbitrary parcel identifier assigned by the
                          county Assessor to simplify identification and
                          expedite the locating of parcels
                        </span>
                      </th>
                      <td>{property.APN || "-"}</td>
                    </tr>

                    <tr>
                      <th>
                        {" "}
                        APN Sequence #
                        <span className="tip">
                          Internal sequence number assigned to Assessor Parcel
                          Number
                        </span>
                      </th>
                      <td>{property.APNSeqNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        {" "}
                        FIPS
                        <span className="tip">
                          The FIPS county code is a five-digit Federal
                          Information Processing Standard (FIPS) code that
                          uniquely identifies counties and county equivalents in
                          the United States. (V014)
                        </span>
                      </th>
                      <td>{property.FIPS || "-"}</td>
                    </tr>
                    <tr>
                      <th> County Name</th>
                      <td>{property.CountyName || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Direction Left
                        <span className="tip">Direction of the street</span>
                      </th>
                      <td>{property.SitusDirectionLeft || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Street
                        <span className="tip">
                          Name or number of the street.
                        </span>
                      </th>
                      <td>{property.SitusStreet || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Mode
                        <span className="tip">Suffix of the Street</span>
                      </th>
                      <td>{property.SitusMode || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Direction Right
                        <span className="tip">Direction of the street</span>
                      </th>
                      <td>{property.SitusDirectionRight || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        ZIP 5
                        <span className="tip">
                          Five digit code assigned by the USPS
                        </span>
                      </th>
                      <td>{property.SitusZIP5 || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        ZIP 4
                        <span className="tip">
                          Four digit code assigned by the USPS
                        </span>
                      </th>
                      <td>{property.SitusZIP4 || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Carrier Code
                        <span className="tip">
                          Four digit code used by the local mail carrier to
                          identify delivery path
                        </span>
                      </th>
                      <td>{property.SitusCarrierCode || "-"}</td>
                    </tr>

                    <tr>
                      <th>
                        Land Use Code
                        <span className="tip">
                          An established Land Use code converted from various
                          county Land Use codes. Land Use code standardized for
                          all counties.
                        </span>
                      </th>
                      <td>{property.PropertyTypeDetail || "-"}</td>
                    </tr>
                    {/* <tr><td colSpan={2}><div className="mt-3"></div></td></tr> */}
                    {/* <tr>
                      <th>
                        County Land Use
                        <span className="tip">
                          Land Use as established by the County.
                        </span>
                      </th>
                      <td>{property.CountyLandUseCode || "-"}</td>
                    </tr> */}
                    <tr>
                      <th>
                        School District Name
                        <span className="tip">
                          Standardized school dirstrict name.
                        </span>
                      </th>
                      <td>{property.SchoolDistrictName || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Tax Account Number
                        <span className="tip">
                          When provided in the assessment files, an arbitrary
                          parcel identifier usually assigned by the County
                          Treasurer for tax purposes.
                        </span>
                      </th>
                      <td>{property.TaxAccountNumber || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Full Street Address
                        <span className="tip">
                          Combined street address of the property
                        </span>
                      </th>
                      <td>{property.SitusFullStreetAddress || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        House No.
                        <span className="tip">
                          House number of the property address
                        </span>
                      </th>
                      <td>{property.SitusHouseNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        House No. Suffix
                        <span className="tip">
                          Alpha digits found to the right of the house number of
                          the property address
                        </span>
                      </th>
                      <td>{property.SitusHouseNbrSuffix || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Unit Type
                        <span className="tip">
                          The type used in the property address for the unit.
                        </span>
                      </th>
                      <td>{property.SitusUnitType || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Unit Number
                        <span className="tip">
                          The unit or suite number of the property address
                        </span>
                      </th>
                      <td>{property.SitusUnitNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        City
                        <span className="tip">
                          The city for the property address
                        </span>
                      </th>
                      <td>{property.SitusCity || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        State
                        <span className="tip">
                          Two letter state abbreviation
                        </span>
                      </th>
                      <td>{property.SitusState || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Latitude
                        <span className="tip">
                          FA standard latitude of the property
                        </span>
                      </th>
                      <td>{property.SitusLatitude || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Longitude
                        <span className="tip">
                          FA standard longitude of the property
                        </span>
                      </th>
                      <td>{property.SitusLongitude || "-"}</td>
                    </tr>
                    {/* <tr>
                      <th>
                        Geo Status Code
                        <span className="tip">
                          Code describing the accuracy of the lat/long
                        </span>
                      </th>
                      <td>{property.SitusGeoStatusCode || "-"}</td>
                    </tr> */}
                    {/* <tr>
                      <th>Property Classification
                      <span className="tip">
                      A general code used to easily recognize specific property types (e.g., Residential, Commercial, Office).
                        </span>
                      </th>
                      <td>{property.PropertyClassID || "-"}</td>
                    </tr> */}
                    <tr>
                      <th>
                        Property Type
                        <span className="tip">
                          The type of real estate or the type of property in
                          general
                        </span>
                      </th>
                      <td>{property.PropertyType || "-"}</td>
                    </tr>
                    {/* <tr><td colSpan={2}><div className="mt-3"></div></td></tr> */}
                    <tr>
                      <th>
                        Zoning
                        <span className="tip">
                          Zoning of a property as assigned by the assessor of a
                          municipality.
                        </span>
                      </th>
                      <td>{property.Zoning || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Lot Information */}
            <h4 className="tabHeading">Lot Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Lot Size Frontage Feet
                        <span className="tip">
                          The linear feet across the front of the lot.
                        </span>
                      </th>
                      <td>{property.LotSizeFrontageFeet || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Lot Size Depth Feet
                        <span className="tip">
                          The linear feet between the front and back of the lot.
                        </span>
                      </th>
                      <td>{property.LotSizeDepthFeet || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Lot Size Acres
                        <span className="tip">
                          This field contains the total area measurement of the
                          land in acres.
                        </span>
                      </th>
                      <td>{property.LotSizeAcres || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Lot Size SqFt
                        <span className="tip">
                          This field contains the total area measurement of the
                          land in square feet.
                        </span>
                      </th>
                      <td>{property.LotSizeSqFt || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Lot Code
                        <span className="tip">
                          Identifies properties which include more than one lot
                          or partial lots.
                        </span>
                      </th>
                      <td>{property.LotCode || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Lot #
                        <span className="tip">
                          The individual lot(s) which comprise the property. The
                          actual lot number(s) such as in a tract or
                          subdivision. If more than one, as many multiple lot
                          numbers as allowed by the field length are entered,
                          separated with a comma (,) or ampersand (&). A hyphen
                          is used to indicate a range (-).
                        </span>
                      </th>
                      <td>{property.LotNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Land Lot
                        <span className="tip">
                          A large portion or tract of land (which may also
                          encompass many individual blocks or lots) in which the
                          property is located.
                        </span>
                      </th>
                      <td>{property.LandLot || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Building Information */}
            <h4 className="tabHeading">Building Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Building Area
                        <span className="tip">
                          The Building Square Footage that can most accurately
                          be used for assessments or comparable (e.g., Living,
                          Adjusted, Gross).
                        </span>
                      </th>
                      <td>{property.BuildingArea || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Building Area Indication
                        <span className="tip">
                          The codes appearing in this field indicates the source
                          used to populate the BuildingArea field (e.g., Living,
                          Adjusted, Gross).
                        </span>
                      </th>
                      <td>{property.BuildingAreaInd || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Building Sq. Ft.
                        <span className="tip">
                          The size of the building in Square Feet. This field is
                          most commonly populated as a cumulative total when a
                          county does not differentiate between Living and
                          Non-living areas.
                        </span>
                      </th>
                      <td>{property.SumBuildingSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Living Area Sq. Ft.
                        <span className="tip">
                          This is the area of a building that is used for
                          general living. This is typically the area of a
                          building that is heated or air conditioned and does
                          not include Garage, Porch or Basement square footage.
                        </span>
                      </th>
                      <td>{property.SumLivingAreaSqFt || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Sum Ground Floor Sq. Ft.
                        <span className="tip">
                          This is the square footage of the ground Floor.
                        </span>
                      </th>
                      <td>{property.SumGroundFloorSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Gross Area Sq. Ft.
                        <span className="tip">
                          This is the square footage for the entire building.
                          Typically this represents all square feet under the
                          roof.
                        </span>
                      </th>
                      <td>{property.SumGrossAreaSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Adj Area Sq. Ft.
                        <span className="tip">
                          This is the square footage used by the county or local
                          taxing / assessment authority to determine Improvement
                          Value. This figure is typically 100% of the living
                          area, plus lower percentage of non-living area.
                        </span>
                      </th>
                      <td>{property.SumAdjAreaSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Attic Sq. Ft.
                        <span className="tip">
                          This is the Attic square footage (Finished and
                          unfinished)
                        </span>
                      </th>
                      <td>{property.AtticSqFt || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Attic Unfinished Sq. Ft.
                        <span className="tip">
                          This is the Unfinished Attic square footage
                        </span>
                      </th>
                      <td>{property.AtticUnfinishedSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Attic Finished Sq. Ft.
                        <span className="tip">
                          This is the Finished Attic square footage
                        </span>
                      </th>
                      <td>{property.AtticFinishedSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Basement Sq. Ft.
                        <span className="tip">
                          This is total square footage associated with Basement
                          portion of a building. This would include both
                          finished and unfinished areas.
                        </span>
                      </th>
                      <td>{property.SumBasementSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Basement Unfinished Sq. Ft.
                        <span className="tip">
                          This is the total unfinished square footage of the
                          basement
                        </span>
                      </th>
                      <td>{property.BasementUnfinishedSqFt || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Basement Finished Sq. Ft.
                        <span className="tip">
                          This is the total finished square footage of the
                          basement
                        </span>
                      </th>
                      <td>{property.BasementFinishedSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Site Influence
                        <span className="tip">Type of Site Influence.</span>
                      </th>
                      <td>{property.SiteInfluence || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Sum Garage Sq. Ft.
                        <span className="tip">
                          This is the total square footage of the primary garage
                          or parking area (i.e., commercial). This includes both
                          finished and unfinished areas.
                        </span>
                      </th>
                      <td>{property.SumGarageSqFt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Year Built
                        <span className="tip">
                          Construction year of the building
                        </span>
                      </th>
                      <td>{property.YearBuilt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Effective Year Built
                        <span className="tip">
                          The year the latest significant construction occurred
                          on the building.
                        </span>
                      </th>
                      <td>{property.EffectiveYearBuilt || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Bedrooms
                        <span className="tip">
                          Total number of bedroom contained in the primary
                          building.
                        </span>
                      </th>
                      <td>{property.Bedrooms || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Total Rooms
                        <span className="tip">Total number of rooms.</span>
                      </th>
                      <td>{property.TotalRooms || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Bath Total
                        <span className="tip">
                          Total calculated number of bath rooms
                        </span>
                      </th>
                      <td>{property.BathTotalCalc || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Bath Full
                        <span className="tip">
                          Number of full bathrooms in a building
                        </span>
                      </th>
                      <td>{property.BathFull || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Amenities
                        <span className="tip">
                          Amenities associated with the porperty (alarm system,
                          fire sprinklers, club house….)
                        </span>
                      </th>
                      <td>{property.Amenities || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Pool Code
                        <span className="tip">
                          Type of Pool installed on the property
                        </span>
                      </th>
                      <td>{property.PoolCode || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Residential Units
                        <span className="tip">
                          Number of Residential, Apartment Units
                        </span>
                      </th>
                      <td>{property.SumResidentialUnits || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sum Commercial Units
                        <span className="tip">
                          Number of Business/Commercial Units.
                        </span>
                      </th>
                      <td>{property.SumCommercialUnits || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Subdivision Name
                        <span className="tip">
                          The name of the subdivision, plat, or tract in which
                          the property is located.
                        </span>
                      </th>
                      <td>{property.SubdivisionName || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Tab>

          {/* Ownership And Tax Details */}
          <Tab
            eventKey="profile"
            title={
              <>
                Ownership & <br /> Tax Details
              </>
            }
          >
            <h4 className="tabHeading">Ownership</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    {/* {addresFirstCol?.map((col1, c) => (
                                            <tr key={c}>
                                                <th>{col1?.head}
                                                    {c === 1 && <span className='tip'>Assessor's Parcel Number or Parcel Identification Number.  An arbitrary parcel identifier assigned by the county Assessor to simplify identification and expedite the locating of parcels</span>}
                                                </th>
                                                <td className={`${c === 1 && 'blur'}`}>{col1?.value}</td>
                                            </tr>
                                        ))} */}
                    
                    <tr>
                      <th>
                        Owner 1 First Name
                        <span className="tip">First Owner First name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner1FirstName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 1 Middle Name
                        <span className="tip">First Owner Middle name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner1MiddleName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 1 Last Name
                        <span className="tip">First Owner Last name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner1LastName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 1 Corporation Ind
                        <span className="tip">
                          First Property Owner is identified as a corporation.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner1CorpInd || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Owner 2 Corporation Ind
                        <span className="tip">
                          Property Owner is identified as a corporation.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner2CorpInd || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 2 First Name
                        <span className="tip">Second Owner First name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner2FirstName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 2 Middle Name
                        <span className="tip">Second Owner Middle Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner2MiddleName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner 2 Last Name
                        <span className="tip">Second Owner Last Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Owner2LastName || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Owner NAME 1 FULL
                        <span className="tip">First Full Owner Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.OwnerNAME1FULL || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Owner NAME 2 FULL
                        <span className="tip">Second Full Owner Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.OwnerNAME2FULL || "-"}
                      </td>
                    </tr>
                    {/* <tr>
                                            <th>Owner Age</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr>
                                        <tr>
                                            <th>Deceased Status</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr>
                                        <tr>
                                            <th>Owner Phone # (Up to 5 #'s)</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr>
                                        <tr>
                                            <th>DNC/Know Litigator Status</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr>
                                        <tr>
                                            <th>Phone Type</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr>
                                        <tr>
                                            <th>Email (Up to 5 emails)</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName}</td>
                                        </tr> */}
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Owner Occupied
                        <span className="tip">
                          Flag if property is owner occupied
                        </span>
                      </th>
                      <td>{property.OwnerOccupied || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Owner 1 Ownership Rights
                        <span className="tip">
                          Code indicating the rights an owner has to the
                          property
                        </span>
                      </th>
                      <td>{property.Owner1OwnershipRights || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Mailing Full Street Address
                        <span className="tip">Combined mailing address</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingFullStreetAddress || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Mailing House #
                        <span className="tip">
                          House number of the mailing address
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingHouseNbr || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Mailing House # Suffix
                        <span className="tip">
                          Alpha digits found to the right of the house number of
                          the mailing address
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingHouseNbrSuffix || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Mailing City
                        <span className="tip">
                          The city for the property address
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingCity || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Mailing State
                        <span className="tip">
                          Two letter state abbreviation
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingState || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Mailing ZIP 5
                        <span className="tip">
                          Five digit code assigned by the USPS
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingZIP5 || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Mailing ZIP 4
                        <span className="tip">
                          Four digit code assigned by the USPS
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.MailingZIP4 || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Relative Information */}
            {/* <h4 className="tabHeading">Relative Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                     <tr>
                                            <th>Mailing ZIP 4</th>
                                            <td className={`${!isSubscribedUser && 'blur'}`}>{property.SubdivisionName || '-'}</td>
                                        </tr> 
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody></tbody>
                </Table>
              </Col>
            </Row>
             */}
            {/* Previous Owner Information 
            <h4 className="tabHeading">Previous Owners Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody></tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody></tbody>
                </Table>
              </Col>
            </Row>
            */}
            {/* Assessement Information */}
            <h4 className="tabHeading">Assessement Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Assessed Total Value
                        <span className="tip">
                          The Total Assessed Value of the Parcel's Land &
                          Improvement values.
                        </span>
                      </th>
                      <td>
                        {property.AssdTotalValue
                          ? "$" +
                            Number(property.AssdTotalValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Assessed Land Value
                        <span className="tip">
                          The current assessed value of the land only (before
                          exemptions, if any) as reported on the current county
                          tax/assessment roll. Whole dollars only.
                        </span>
                      </th>
                      <td>
                        {property.AssdLandValue
                          ? "$" +
                            Number(property.AssdLandValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Assessed Improvement Value
                        <span className="tip">
                          The current assessed value of the improvements only
                          (before exemptions, if any) as reported on the current
                          county tax/assessment roll. Whenever separate fields
                          are provided for additional improved values, this will
                          be the total of all improvement values. Whole dollars
                          only.
                        </span>
                      </th>
                      <td>
                        {property.AssdImprovementValue
                          ? "$" +
                            Number(
                              property.AssdImprovementValue
                            ).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Market Total Value
                        <span className="tip">
                          The Total Market Value of the Parcel's Land &
                          Improvement value
                        </span>
                      </th>
                      <td>
                        {property.MarketTotalValue
                          ? "$" +
                            Number(property.MarketTotalValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Market Value Land
                        <span className="tip">
                          When available from the county, the Market Land Value
                          as determined by the Assessor.
                        </span>
                      </th>
                      <td>
                        {property.MarketValueLand
                          ? "$" +
                            Number(property.MarketValueLand).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Market Value Improvement
                        <span className="tip">
                          When available from the county, the Market Improvement
                          Value as determined by the Assessor.
                        </span>
                      </th>
                      <td>
                        {property.MarketValueImprovement
                          ? "$" +
                            Number(
                              property.MarketValueImprovement
                            ).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Assessed Year
                        <span className="tip">
                          Year of the Assessed values on a property
                        </span>
                      </th>
                      <td>{property.AssdYear || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Market Year
                        <span className="tip">
                          Year of the Market values on a property
                        </span>
                      </th>
                      <td>{property.MarketYear || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Tax Information */}
            <h4 className="tabHeading">Tax Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Tax Amount
                        <span className="tip">
                          Amount of tax due from a property owner
                        </span>
                      </th>
                      <td>
                        {property.TaxAmt
                          ? "$" + Number(property.TaxAmt).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Tax Year
                        <span className="tip">Year taxes are billed</span>
                      </th>
                      <td>{property.TaxYear || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Tax Deliquent Year
                        <span className="tip">
                          The initial tax year of delinquency.
                        </span>
                      </th>
                      <td>{property.TaxDeliquentYear || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Tax Rate Code Area
                        <span className="tip">
                          Represents separate tax jurisdictions within the
                          county as provided on the county tax/assessment roll.
                        </span>
                      </th>
                      <td>{property.TaxRateCodeArea || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Tab>

          <Tab
            eventKey="longer-tab"
            title={
              <>
                Sales & Listing <br /> History
              </>
            }
          >
            <h4 className="tabHeading">Sale Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Sale Transaction ID
                        <span className="tip">
                          Unique number assigned to each transaction.
                        </span>
                      </th>
                      <td>{property.CurrentSaleTransactionId || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sale Doc. #
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td>{property.CurrentSaleDocNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Sale Book
                        <span className="tip">Recorders Book Number</span>
                      </th>
                      <td>{property.CurrentSaleBook || "-"}</td>
                    </tr>
                    {/* <tr>
                      <th>Sale Page</th>
                      <td>{property.TaxRateCodeArea || "-"}</td>
                    </tr> */}
                    <tr>
                      <th>
                        Sale Recording Date
                        <span className="tip">
                          Date the transaction was recorded by the
                          county/jurisdiction.
                        </span>
                      </th>
                      <td>
                        {property.CurrentSaleRecordingDate
                          ? moment(property.CurrentSaleRecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Sale Contract Date
                        <span className="tip">
                          Date of execution of the document
                        </span>
                      </th>
                      <td>
                        {property.CurrentSaleContractDate
                          ? moment(property.CurrentSaleContractDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Sales Price
                        <span className="tip">
                          Sale price of the recorded transaction
                        </span>
                      </th>
                      <td>
                        {property.CurrentSalesPrice
                          ? "$" +
                            Number(property.CurrentSalesPrice).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Sale Buyer 1 Full Name
                        <span className="tip">Buyer 1 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.CurrentSaleBuyer1FullName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Sale Buyer 2 Full Name
                        <span className="tip">Buyer 2 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.CurrentSaleBuyer2FullName || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Sale Seller 1 Full Name
                        <span className="tip">Seller 1 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.CurrentSaleSeller1FullName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Sale Seller 2 Full Name
                        <span className="tip">Seller 2 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.CurrentSaleSeller2FullName || "-"}
                      </td>
                    </tr>

                    <tr>
                      <th>
                        Concurrent Mtg. 1 Doc. Nbr.
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td>{property.ConcurrentMtg1DocNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Book
                        <span className="tip">Recorders Book Number</span>
                      </th>
                      <td>{property.ConcurrentMtg1Book || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Recording Date
                        <span className="tip">
                          Date the transaction was recorded by the
                          county/jurisdiction.
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg1RecordingDate
                          ? moment(property.ConcurrentMtg1RecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Loan Amt.
                        <span className="tip">
                          The amount of the mortgage on the recorded document.
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg1LoanAmt
                          ? "$" +
                            Number(
                              property.ConcurrentMtg1LoanAmt
                            ).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Lender
                        <span className="tip">
                          The name of the lender issuing the mortgage.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg1Lender || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Term
                        <span className="tip">
                          Mortgage term in months or years.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg1Term || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Interest Rate
                        <span className="tip">Mortgage 1 Interest Rate</span>
                      </th>
                      <td>{property.ConcurrentMtg1InterestRate || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Loan Due Date
                        <span className="tip">
                          Maturity date or the final due date of the loan
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg1LoanDueDate
                          ? moment(property.ConcurrentMtg1LoanDueDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Loan Type
                        <span className="tip">
                          The type of document use to issue the mortgage
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg1LoanType || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 1 Type Financing
                        <span className="tip">
                          The financing type of mortgage.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg1TypeFinancing || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Doc Nbr.
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td>{property.ConcurrentMtg2DocNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Book
                        <span className="tip">Recorders Book Number</span>
                      </th>
                      <td>{property.ConcurrentMtg2Book || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Recording Date
                        <span className="tip">
                          Date the transaction was recorded by the
                          county/jurisdiction.
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg2RecordingDate
                          ? moment(property.ConcurrentMtg2RecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Loan Amt.
                        <span className="tip">
                          The amount of the mortgage on the recorded document.
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg2LoanAmt
                          ? "$" +
                            Number(
                              property.ConcurrentMtg2LoanAmt
                            ).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Lender
                        <span className="tip">
                          The name of the lender issuing the mortgage.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg2Lender || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Term
                        <span className="tip">
                          Mortgage term in months or years.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg2Term || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Interest Rate
                        <span className="tip">Mortgage 2 Interest Rate</span>
                      </th>
                      <td>{property.ConcurrentMtg2InterestRate || "-"}</td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Loan Due Date
                        <span className="tip">
                          Maturity date or the final due date of the loan.
                        </span>
                      </th>
                      <td>
                        {property.ConcurrentMtg2LoanDueDate
                          ? moment(property.CurrentSaleRecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Loan Type
                        <span className="tip">
                          The type of document use to issue the mortgage.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg2LoanType || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Concurrent Mtg. 2 Type financing
                        <span className="tip">
                          The financing type of mortgage.
                        </span>
                      </th>
                      <td>{property.ConcurrentMtg2Typefinancing || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Prev Sale Information */}
            <h4 className="tabHeading">Prev Sale Information</h4>
            {!property.PrevSaleRecordingDate && !property.PrevSaleContractDate && !property.PrevSaleSeller1FullName ? <div>No data available</div> : (
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Prev. Sale Transaction ID
                        <span className="tip">
                          Unique number assigned to each transaction.
                        </span>
                      </th>
                      <td>{property.PrevSaleTransactionId || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sale Doc. Nbr.
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td>{property.PrevSaleDocNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sale Book
                        <span className="tip">Recorders Book Number</span>
                      </th>
                      <td>{property.PrevSaleBook || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sale Recording Date
                        <span className="tip">
                          Date the transaction was recorded by the
                          county/jurisdiction.
                        </span>
                      </th>
                      <td>
                        {property.PrevSaleRecordingDate
                          ? moment(property.PrevSaleRecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Prev. Sale Contract Date
                        <span className="tip">
                          Date of execution of the document
                        </span>
                      </th>
                      <td>
                        {property.PrevSaleContractDate
                          ? moment(property.PrevSaleContractDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sale Document Type
                        <span className="tip">
                          The type of document use to record the sale/transfer
                          of a property
                        </span>
                      </th>
                      <td>{property.PrevSaleDocumentType || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sales Price
                        <span className="tip">
                          Sale price of the recorded transaction
                        </span>
                      </th>
                      <td>
                        {property.PrevSalesPrice
                          ? "$" +
                            Number(
                              property.ConcurrentMtg2LoanAmt
                            ).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Sale Buyer 1 Full Name
                        <span className="tip">Buyer 1 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PrevSaleBuyer1FullName || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Prev. Sale Buyer 2 Full Name
                        <span className="tip">Buyer 2 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PrevSaleBuyer2FullName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Prev Sale Seller 1 Full Name
                        <span className="tip">Seller 1 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PrevSaleSeller1FullName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Prev Sale Seller 2 Full Name
                        <span className="tip">Seller 2 Full Name</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PrevSaleSeller2FullName || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Doc. Nbr.
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td>{property.PrevMtg1DocNbr || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Book
                        <span className="tip">Recorders Book Number</span>
                      </th>
                      <td>{property.PrevMtg1Book || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Recording Date
                        <span className="tip">
                          Date the transaction was recorded by the
                          county/jurisdiction.
                        </span>
                      </th>
                      <td>
                        {property.PrevMtg1RecordingDate
                          ? moment(property.PrevMtg1RecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Loan Amt.
                        <span className="tip">
                          The amount of the mortgage on the recorded document
                        </span>
                      </th>
                      <td>
                        {property.PrevMtg1LoanAmt
                          ? "$" +
                            Number(property.PrevMtg1LoanAmt).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Lender
                        <span className="tip">
                          The name of the lender issuing the mortgage
                        </span>
                      </th>
                      <td>{property.PrevMtg1Lender || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Term
                        <span className="tip">
                          Mortgage term in months or years.
                        </span>
                      </th>
                      <td>{property.PrevMtg1Term || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Interest Rate
                        <span className="tip">Prev Mortgage Interest Rate</span>
                      </th>
                      <td>{property.PrevMtg1InterestRate || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Loan Due Date
                        <span className="tip">
                          Maturity date or the final due date of the loan
                        </span>
                      </th>
                      <td>
                        {property.PrevMtg1LoanDueDate
                          ? moment(property.PrevMtg1LoanDueDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Loan Type
                        <span className="tip">
                          The type of document use to issue the mortgage
                        </span>
                      </th>
                      <td>{property.PrevMtg1LoanType || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Prev. Mtg. 1 Type Financing
                        <span className="tip">Type of mortgage</span>
                      </th>
                      <td>{property.PrevMtg1TypeFinancing || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            )}
            {/* Listing Information */}
            <h4 className="tabHeading">Listing Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Is Listed Flag
                        <span className="tip">
                          Property is listed or not (y/n)
                        </span>
                      </th>
                      <td>{property.IsListedFlag || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        Is Listed Flag Date
                        <span className="tip">
                          The date the property was listed.
                        </span>
                      </th>
                      <td>
                        {property.IsListedFlagDate
                          ? moment(property.IsListedFlagDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>Is Listed Price Range</th>
                      <td>
                        {property.IsListedPriceRange
                          ? "$" + property.IsListedPriceRange
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Tab>

          <Tab
            eventKey="contact"
            title={
              <>
                Financial & <br /> Foreclosure Data
              </>
            }
          >
            <h4 className="tabHeading">Valuation Information</h4>
            {!property.CurrentAVMValue && !property.vLowValue && !property.vHighValue ? <div>No data available</div> : (
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>Current AVM Value</th>
                      <td>
                        {property.CurrentAVMValue
                          ? "$" +
                            Number(property.CurrentAVMValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>Low Value</th>
                      <td>
                        {property.vLowValue
                          ? "$" + Number(property.vLowValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>High Value</th>
                      <td>
                        {property.vHighValue
                          ? "$" + Number(property.vHighValue).toLocaleString()
                          : "-"}
                      </td>
                    </tr>

                    {/* {addresFirstCol?.map((col1, c) => (
                      <tr key={c}>
                        <th>
                          {col1?.head}
                          {c === 1 && (
                            <span className="tip">
                              Assessor's Parcel Number or Parcel Identification
                              Number.  An arbitrary parcel identifier assigned
                              by the county Assessor to simplify identification
                              and expedite the locating of parcels
                            </span>
                          )}
                        </th>
                        <td className={`${c === 1 && "blur"}`}>
                          {col1?.value}
                        </td>
                      </tr>
                    ))} */}
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>Confidence Score</th>
                      <td>{property.vConfidenceScore || "-"}</td>
                    </tr>
                    <tr>
                      <th>Standard Deviation</th>
                      <td>{property.vStandardDeviation || "-"}</td>
                    </tr>
                    <tr>
                      <th>Valuation Date</th>
                      <td>
                        {property.vValuationDate
                          ? moment(property.vValuationDate).format("MM/DD/YYYY")
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            )}
            {/* Pre-Foreclosure Information */}
            <h4 className="tabHeading">Pre-Foreclosure Information</h4>
            {!property.PFCTypeDesc && !property.RecordingDate && !property.AuctionDate ? <div>No data available</div> : (
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        PFC Type
                        <span className="tip">
                          Grouped Pre Foreclosure Types
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PFCTypeDesc || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Recording Date
                        <span className="tip">
                          The official date of recordation for the foreclosure
                          document.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.RecordingDate
                          ? moment(property.RecordingDate).format("MM/DD/YYYY")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Original NOD Recording Date
                        <span className="tip">
                          Recording Date of the original Notice of Default
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.OriginalNODRecordingDate
                          ? moment(property.OriginalNODRecordingDate).format(
                              "MM/DD/YYYY"
                            )
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Original NOD Document No.
                        <span className="tip">
                          Recorders Document Number of the original Notice of
                          Default
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.OriginalNODDocumentNumber || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Document Type
                        <span className="tip">
                          Document type field that identifies the foreclosure
                          record type.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.DocumentTypeDesc || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Document Nbr.
                        <span className="tip">Recorders Document Number</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.DocumentNbr || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Default Date
                        <span className="tip">
                          The Date Mortgage Default occurred.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.DefaultDate
                          ? moment(property.DefaultDate).format("MM/DD/YYYY")
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Auction Date
                        <span className="tip">
                          The scheduled Auction Date as reported on the Notice
                          of Sale.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.AuctionDate
                          ? moment(property.AuctionDate).format("MM/DD/YYYY")
                          : "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Auction Time
                        <span className="tip">
                          The scheduled Auction Time as reported on the Notice
                          of Sale.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.AuctionTime || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Auction Location
                        <span className="tip">
                          The Street Address where the auction is scheduled to
                          take place, usually reported on the Notice of Sale.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.AuctionLocation || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Auction City
                        <span className="tip">
                          The City where the auction is scheduled to take place
                          as reported on the Notice of Sale.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.AuctionCity || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Auction Minimum Bid Amount
                        <span className="tip">
                          The minimum bid amount as reported on the Notice of
                          Sale
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.AuctionMinimumBidAmount || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Loan Number
                        <span className="tip">
                          Loan Number from pre foreclosure document.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.LoanNumber || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Case Number
                        <span className="tip">
                          Court Case number when available.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.CaseNumber || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Unpaid Balance
                        <span className="tip">
                          Unpaid principal amount of the loan as stated on the
                          foreclosure document.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.UnpaidBalance
                          ? "$" +
                            Number(property.UnpaidBalance).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Original Lender Name
                        <span className="tip">
                          lender name on the original loan document
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.OriginalLenderName || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Trustee First Name & Middle Initial
                        <span className="tip">
                          First name and middle initial of Trustee
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property["TrusteeFirstName&MiddleInitial"] || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Trustee Last Name OR Corporation Name
                        <span className="tip">
                          Last Name or Corporation Name of the Trustee
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeLastNameORCorporationName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Telephone Number
                        <span className="tip">Phone number of Trustee</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeTelephoneNumber || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Full Street Address
                        <span className="tip">Full Trustee Mail Address</span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeFullStreetAddress || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Unit Number
                        <span className="tip">
                          The unit or suite number of the property address
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeUnitNumber || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Trustee City Name
                        <span className="tip">
                          The city for the property address
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeCityName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee State Code
                        <span className="tip">
                          Two letter state abbreviation
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeStateCode || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Zip Code
                        <span className="tip">
                          Five digit code assigned by the USPS
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeZipCode || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Zipplus 4
                        <span className="tip">
                          Four digit code assigned by the USPS
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeZipplus4 || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Trustee Care of Name
                        <span className="tip">
                          The name to send inquiries to the attention of
                          Trustee.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeCareofName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Trustee Sale Number
                        <span className="tip">
                          Number assigned by the Trustee for the purpose of
                          tracking the foreclosure for the given property.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.TrusteeSaleNumber || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Borrower 1 First Name & Middle Name
                        <span className="tip">
                          First Name and Middle initial of the first Borrower
                          involved in the foreclosure actions
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property["Borrower1FirstName&MiddleName"] || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Borrower 1 Last Name OR Corporation Name
                        <span className="tip">
                          Last name or company name of the first borrower
                          involved in the foreclosure action.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Borrower1LastNameORCorporationName || "-"}
                      </td>
                    </tr>
                    <tr><td colSpan={2}><div className="mt-3"></div></td></tr>
                    <tr>
                      <th>
                        Borrower 2 First Name & Middle Name
                        <span className="tip">
                          First Name and Middle initial of the second Borrower
                          involved in the foreclosure actions
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property["Borrower2FirstName&MiddleName"] || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Borrower 2 Last Name OR Corporation Name
                        <span className="tip">
                          Last name or company name of the second borrower
                          involved in the foreclosure action.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.Borrower2LastNameORCorporationName || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            )}
          </Tab>
          <Tab
            eventKey="blog"
            title={
              <>
                Risk & Market <br /> Insights
              </>
            }
          >
            <h4 className="tabHeading">Vacant Information</h4>
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>Is Vacant</th>
                      <td>{property.VacantFlag || "-"}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>Vacant Date</th>
                      <td>
                        {property.VacantFlagDate
                          ? moment(property.VacantFlagDate).format("MM/DD/YYYY")
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            {/* Scores (Propensity to default) Information */}
            <h4 className="tabHeading">Scores (Propensity to default)</h4>
            {!property.DefaultScore && !property.RefiIntelScore_Conventional && !property.RefiIntelScore_FHA ? <div>No data available</div> : (
            <Row>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        Default Score
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood that a homeowner will default
                          on their loan over the next 3-4 months. Higher score =
                          greater likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.DefaultScore || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Refi Intel Score - Conventional
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood a homeowner will obtain a
                          conventional refi over the next 3-4 months. Higher
                          score = greater likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.RefiIntelScore_Conventional || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Refi Intel Score - FHA
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood a homeowner will obtain an FHA
                          refi over the next 3-4 months. Higher score = greater
                          likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.RefiIntelScore_FHA || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Home Equity Intel Score - Line of Credit
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood a homeowner will obtain a home
                          equity loan or line of credit over the next 3-4
                          months. Higher score = greater likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.HomeEquityIntelScore_LineofCredit || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <Table className="tab-table">
                  <tbody>
                    <tr>
                      <th>
                        RefiIntel Score - Cashout
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood of a cashout-type refinance
                          over the next 3-4 months. Higher score = greater
                          likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.RefiIntelScore_Cashout || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Purchase Intel Score
                        <span className="tip">
                          Based on a national average score of 100, this score
                          predicts the likelihood that an existing homeowner
                          will move and will need a purchase mortgage over the
                          next year. Higher score = greater likelihood.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.PurchaseIntelScore || "-"}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        Liquid Assets Score
                        <span className="tip">
                          Based on a national average score of 100, this score
                          rank-orders households by their estimated liquid
                          assets (cash and marketable securities), based on
                          housing and borrower info plus external data.
                        </span>
                      </th>
                      <td className={`${!isSubscribedUser && "blur"}`}>
                        {property.LiquidAssetsScore || "-"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            )}
          </Tab>
        </Tabs>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShowPropertyDetail;
